import { createStyles } from '@mantine/core';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';
import { Text } from '~/domains/design-system/Text';

export type WarningNoteType = BaseField & {
  type: 'WarningNote';
  note: string;
};

const useStyles = createStyles((theme) => ({
  label: {
    color: theme.colors.orange[3],
  },
}));

function WarningNoteElement({ field }: StaticFieldProps<WarningNoteType>) {
  const { classes } = useStyles();

  return (
    <div>
      <Text variant="body-large" className={classes.label}>
        {field.note}
      </Text>
    </div>
  );
}
const Descriptor: FieldDescriptor<WarningNoteType> = {
  FieldComponent: WarningNoteElement,
  name: 'WarningNote',
};

export default Descriptor;
